import { ClassbookV2OverviewMyCourseEntry } from '../../mnspro-cloud';
import { LessonBasicResponse } from '../../mnspro-cloud/api/v2';

export const LessonBasicResponseToClassbookV2OverviewMyCourseEntry = (
  lesson: LessonBasicResponse,
): ClassbookV2OverviewMyCourseEntry => {
  return {
    classNames: lesson.classes.map(c => c.name),
    courseName: lesson.course.name,
    gradeName: lesson.grades.length > 0 ? lesson.grades[0].name : '',
    id: lesson.course.id,
    nextOccurrenceStart: lesson.start,
    nextOccurenceEnd: lesson.end,
    color: lesson.course.color ?? undefined,
  };
};
